export enum PaymentProviders {
  PAYBROKERS = 'PAYBROKERS',
  PAGFAST = 'PAGFAST',
  PAYBROKERS_SOLUTIONS = 'PAYBROKERS_SOLUTIONS',
  PAYBROKERS_IP = 'PAYBROKERS_IP',
  PIXS = 'PIXS',
  LOCAL = 'LOCAL',
  MODAPAY = 'MODAPAY',
  OKTO = 'OKTO',
  OKP = 'OKP',
  XGATE = 'XGATE',
  ZROBANK = 'ZROBANK',
}
